import moment from 'moment';
import { DATE } from '../constants';
import { Option } from '../customTypes';
import { DashboardFilters, FormattedFilters } from '../types/dashboardFilters';

export const titleToSnakeCase = (title: string) => {
  return title
    .replace(/\s+/g, '_') // Replace spaces with underscores
    .replace(/([a-z])([A-Z])/g, '$1_$2') // Add underscore between camelCase words
    .toLowerCase(); // Convert to lowercase
};

const formatTimeframeFilter = (
  startDate: string | undefined,
  endDate: string | undefined
): string => {
  return [
    startDate ? moment(startDate).format(DATE.SHORT_FORMAT) : '',
    endDate ? moment(endDate).format(DATE.SHORT_FORMAT) : '',
  ]
    .filter(Boolean)
    .join(' - ');
};

type FilterOptions = {
  learningTeamsOptions?: Option[];
};

export const formatDashboardFilters = (
  filters: DashboardFilters,
  filterOptions: FilterOptions = {}
): Array<FormattedFilters> => {
  const formattedFilters: Array<FormattedFilters> = [];
  if (filters.startDate || filters.endDate) {
    formattedFilters.push({
      key: 'timeframe',
      label: formatTimeframeFilter(filters.startDate, filters.endDate),
    });
  }
  if (filters.learningTeams && filters.learningTeams.length > 0) {
    const { learningTeamsOptions = [] } = filterOptions;
    const labels = filters.learningTeams.map((teamId) => {
      const team = learningTeamsOptions.find(
        (option) => option.value === teamId
      );
      return team?.label || teamId;
    });
    formattedFilters.push({
      key: 'learningTeams',
      label: labels.join(', '),
    });
  }

  return formattedFilters;
};
